import Cookies from 'js-cookie';

export default function($el) {
  if($('.cookie-banner').length > 0) {
    return;
  }

  const cookieName = '_maji_consent';

  const userHasConsented = () => {
    if (Cookies.get(`${cookieName}_for_logged_in_user`)) return true;

    const cookie = Cookies.get(cookieName);

    if (!cookie) return false;

    return JSON.parse(cookie).policy_version >= $el.data('policy-version');
  };

  if(!userHasConsented()) {
    $el.append(
      '<div id="mobile_cookie_banner" class="show-for-mobile-only cookie-banner fixed bottom-0 w-full bg-grey-10 alert-box with-transition">' +
         '<div class="row items-center flex flex-row p-0 border-none">' +
            '<p class="px-0 pb-0 text-left text-cw-black m-0">' +
              'We use cookies to enhance your experience. ' +
              '<a class="underline text-cw-black border-transparent whitespace-no-wrap learn-more-button">Learn More</a>.'  +
            '</p>' +
            '<div class="px-1">' +
              '<button class="button button--grey-50 button--small whitespace-no-wrap">I AGREE</button>' +
            '</div>' +
         '</div>' +
      '</div>' +

      '<div id="cookie_banner" class="show-for-medium-up cookie-banner fixed bottom-0 w-full bg-grey-10 alert-box">' +
         '<div class="row items-center flex flex-col md-flex-row p-0 border-none">' +
            '<p class="px-0 pb-1 md-pb-0 text-center md-text-left text-cw-black m-0">' +
              'We use cookies on our website to personalize your experience and improve our efforts. By continuing, you agree to the terms of our ' +
              '<a class="underline text-cw-black border-transparent whitespace-no-wrap" href="/privacy">Privacy Policy</a>.'  +
            '</p>' +
            '<div class="px-1">' +
              '<button class="button button--grey-50 button--small whitespace-no-wrap">I AGREE</button>' +
            '</div>' +
         '</div>' +
      '</div>'
    );
  }

  const segmentAnonymousId = () => {
    try {
      return window.analytics.user().anonymousId();
    } catch(error) {
      return 'client side error determining segment anonymous id';
    }
  };

  const cookieDomain = () => {
    const domain = '.charitywater.org';

    return ~window.getHostName().indexOf(domain) ? domain : window.getHostName();
  };

  window.getHostName = () => window.location.hostname;

  $('.cookie-banner button').on('click', () => {
    $el.find('.cookie-banner').remove();
    $.post(
      '/cookie_consent_agreements',
      {
        segment_anonymous_id: segmentAnonymousId(),
      }
    ).done(
      (data) => {
        if(!userHasConsented()) {
          Cookies.set(cookieName, data, { expires: 365, domain: cookieDomain() });
        }
      },
    );
  });

  $('#mobile_cookie_banner .learn-more-button').on('click', (e) => {
    e.preventDefault();

    $('#mobile_cookie_banner').addClass('dismissed-mobile-banner');
    $('#cookie_banner').addClass('dismissed-full-banner').removeClass('show-for-medium-up');

    setTimeout(() => {
      $('#cookie_banner').removeClass('dismissed-full-banner');
    }, 0);
  });
}
